import type { DesktopCapability, DesktopDeviceView, DesktopWorkspaceBindingView } from 'shared';
import { http } from './client';

export const desktopApi = {
  setTaskAuthorization: (workspaceId: string, bindingId: string, authorization: import('shared').LocalAuthorizationProfile | null) =>
    http.patch<DesktopWorkspaceBindingView>(`/workspaces/${workspaceId}/desktop-bindings/${bindingId}/task-authorization`, { authorization }),
  devices: () => http.get<DesktopDeviceView[]>('/desktop/devices'),
  bindings: (workspaceId: string) =>
    http.get<DesktopWorkspaceBindingView[]>(`/workspaces/${workspaceId}/desktop-bindings`),
  createBinding: (
    workspaceId: string,
    input: {
      deviceId: string;
      displayName: string;
      capabilities: DesktopCapability[];
      isDefault?: boolean;
    },
  ) => http.post<DesktopWorkspaceBindingView>(`/workspaces/${workspaceId}/desktop-bindings`, input),
  removeBinding: (workspaceId: string, bindingId: string) =>
    http.delete<void>(`/workspaces/${workspaceId}/desktop-bindings/${bindingId}`),
  setDefaultBinding: (workspaceId: string, bindingId: string) =>
    http.patch<DesktopWorkspaceBindingView>(
      `/workspaces/${workspaceId}/desktop-bindings/${bindingId}/default`,
    ),
};
